import angular from 'angular'

import '../../controller/environment'

angular.module('core.application.main').filter('core_application_main_filter_country_terms_url', [
  'core.application.main.controller.environment',
  function (Environment) {
    return function (countryCode) {
      // PAYL-7079 if the country code is given, then the country specific
      // terms url will be returned, otherwise it deliberately falls back to
      // using the U.S. url
      const urls = {
        ES: 'https://www.clearpay.com/es-ES/terms',
        IT: 'https://www.clearpay.com/it-IT/terms',
        FR: 'https://www.clearpay.com/fr-FR/terms',
        AU: Environment.BROCHURE_BASE_URL + '/en-AU/terms-of-service',
        NZ: Environment.BROCHURE_BASE_URL + '/en-NZ/terms-of-service',
        US: Environment.BROCHURE_BASE_URL + '/terms-of-service',
        GB: Environment.BROCHURE_BASE_URL + '/en-GB/terms-of-service',
        CA: Environment.BROCHURE_BASE_URL + '/en-CA/terms-of-service'
      }
      return urls[countryCode] || urls.US
    }
  }
])
